import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FooterNav from "./FooterNav";

const AboutE = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#3d3b6f",
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "700",
              textAlign: "center",
            }}
            color="#fff"
          >
            About video Task
          </Typography>
          <Box> </Box>
        </Box>
        <Box sx={{ minHeight: "100vh", marginTop: 2 }}>
          <Container>
        

            <Grid sx={{ marginBottom: 2 }}>
              <Grid item>
                <Card sx={{ boxShadow: 5, borderRadius: 2 }}>
                  <CardContent>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      Who We Are
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "1.8",
                        color: "#555",
                      }}
                    >
                      video Task is a trusted name in the consumer electronics
                      industry, offering a wide range of cutting-edge products
                      that enhance your entertainment experience. With a rich
                      history of innovation and expertise, we have been serving
                      customers for over three decades, delivering superior
                      technology and exceptional value.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item>
                <Card sx={{ boxShadow: 5, marginTop: 2, borderRadius: 2 }}>
                  <CardContent sx={{ padding: 3 }}>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      Our Mission
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "1.8",
                        color: "#555",
                      }}
                    >
                      Our commitment to quality and customer satisfaction is at
                      the core of everything we do. We understand that our
                      customers expect the best, and that's why we strive to
                      design and develop products that combine the latest
                      technology, user-friendly features, and stylish design.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Grid sx={{ marginBottom: 2 }}>
              <Grid item>
                <Card sx={{ boxShadow: 5, borderRadius: 2 }}>
                  <CardContent>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      History
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "1.8",
                        color: "#555",
                      }}
                    >
                      video Task International Ltd. is the flagship company of
                      Jiwarajka Group. Established in 1968, video Task has come
                      a long way and is now listed on the Bombay Stock Exchange
                      (BSE). It became a public listed company in 1993 and has
                      continued to grow with a strong presence in the market.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item>
                <Card sx={{ boxShadow: 5, marginTop: 2, borderRadius: 2 }}>
                  <CardContent sx={{ padding: 3 }}>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      Our Values
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "1.8",
                        color: "#555",
                      }}
                    >
                      We believe in equal access to technology for all,
                      promoting inclusivity and empowerment. At video Task, we
                      focus on creating products that not only meet the highest
                      standards of performance and reliability but also offer
                      great value for your money.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Third Section: Innovation and Sustainability */}
            <Grid sx={{ marginBottom: 4 }}>
              <Grid item>
                <Card sx={{ boxShadow: 5, borderRadius: 2 }}>
                  <CardContent>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      Innovation & Technology
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "1.8",
                        color: "#555",
                      }}
                    >
                      We take pride in our dedicated team who work tirelessly to
                      bring you the best in consumer electronics. Our commitment
                      to continuous innovation ensures that we stay ahead of the
                      curve and deliver products that exceed your expectations.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item>
                <Card sx={{ boxShadow: 5, marginTop: 2, borderRadius: 2 }}>
                  <CardContent sx={{ padding: 3 }}>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      Sustainability & Social Impact
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "1.8",
                        color: "#555",
                      }}
                    >
                      As a responsible corporate citizen, we also strive to make
                      a positive impact on society and the environment. We are
                      committed to sustainable practices, ethical business
                      conduct, and giving back to the communities we serve.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>
        {/* <img
          src="/images/img33.png"
          width="100%"
          alt="img"
        /> */}
      </div>
      <FooterNav />
    </>
  );
};
export default AboutE;
